// extracted by mini-css-extract-plugin
export default {"pagination":"paginateCard_pagination__zEQhE","active":"paginateCard_active__N-yUn"};